module.exports = "/_next/static/images/gas-55ce7173b94ba6cdf846b5605a312625.svg";